app.controller('stateOfHealthGeneralTakenDrugController', ['$scope', '$state', '$mdDialog', '$translate',
    'edm.applicationModel', 'patientModel', 'takenDrugModel', 'userModel', 'prescribedDrugModel',
    function ($scope, $state, $mdDialog, $translate, applicationModel, patientModel, takenDrugModel,
              userModel, prescribedDrugModel) {

        function setData() {
            $scope.currentUserId = userModel.currentUser.id;
        }


        function setPermissions() {
        }

        function setListeners() {
        }

        function setActions() {
            $scope.addTakenDrug = function() {
                $mdDialog.show({
                    templateUrl: 'edm/application/view/app/patient/popup/stateOfHealth/popup-takenDrug.html',
                    controller: 'popupTakenDrugCreateController'
                }).then(function (data) {
                    patientModel.getStateOfHealth($state.params.patientId).then($scope.listeners.onStateOfHealthLoad);
                }, function () {
                    //cancel
                });
            };

            $scope.updateTakenDrug = function(takenDrug, previewOnly) {
                if(takenDrug.visit && !previewOnly) {
                    if(takenDrug.prescription) {
                        $scope.alert('T.MODULE.PATIENT.DRUG_CONNECTED_WITH_VISIT_CARD_AND_PRESCRIPTION');
                    } else {
                        applicationModel.confirm('T.MODULE.PATIENT.DRUG_CONNECTED_WITH_VISIT_CARD').then(function () {
                            $state.go(Constant.STATE.APP.PATIENT.VIEW.VISIT_CARD_CORRECT, { patientId: takenDrug.patient.id, visitId: takenDrug.visit.id });
                        });
                    }
                    return;
                }

                $mdDialog.show({
                    templateUrl: 'edm/application/view/app/patient/popup/stateOfHealth/popup-takenDrug.html',
                    controller: 'popupTakenDrugUpdateController',
                    resolve: {
                        takenDrugToUpdate: function() {
                            return takenDrug;
                        },
                        preview: function() {
                            return previewOnly;
                        }
                    }
                }).then(function (data) {
                    patientModel.getStateOfHealth($state.params.patientId).then($scope.listeners.onStateOfHealthLoad);
                }, function () {
                    //cancel
                });
            };

            $scope.deleteTakenDrug = function(prescribedDrug) {
                if(prescribedDrug.visit) {
                    if(prescribedDrug.prescription) {
                        $scope.alert('T.MODULE.PATIENT.DRUG_CONNECTED_WITH_VISIT_CARD_AND_PRESCRIPTION');
                    } else {
                        applicationModel.confirm('T.MODULE.PATIENT.DRUG_CONNECTED_WITH_VISIT_CARD').then(function () {
                            $state.go(Constant.STATE.APP.PATIENT.VIEW.VISIT_CARD_CORRECT, { patientId: prescribedDrug.patient.id, visitId: prescribedDrug.visit.id });
                        });
                    }
                } else {
                    var label = prescribedDrug.drug.name;
                    var configPopup = {
                        templateUrl: 'edm/application/view/app/patient/popup/stateOfHealth/popup-delete-confirmation.html',
                        controller: 'popupDeleteWithReasonController',
                        controllerAs: 'deleteConfirmCtrl',
                        skipHide: true,
                        locals: {
                            labels: label,
                            item: angular.copy(prescribedDrug),
                            userModel: userModel,
                            $mdDialog: $mdDialog,
                            message: 'T.MODULE.PATIENT.TAKEN_DRUG_DELETE_CONFIRMATION'
                        }
                    };

                    $mdDialog.show(configPopup).then(function(data) {
                        prescribedDrugModel.update(data).then(function() {
                            patientModel.getStateOfHealth($state.params.patientId).then($scope.listeners.onStateOfHealthLoad);
                        });
                    });

                }
            };

            $scope.userHasAccessToDeleteEntity = function(entity) {
                return !entity.deleted && (entity.author.id === $scope.currentUserId || (entity.author.userType === 'MEDICAL_OFFICE' && userModel.currentUser.userType === Enum.USER_TYPE.DOCTOR));
            };
        }

        function configureInterface() {
        }

        function initialize() {

        }

        setData();
        setPermissions();
        setListeners();
        setActions();
        configureInterface();
        initialize();
    }
]);
